<template lang="pug">
  .socialMediaRoleSlide.blue-background(ref="SocialMedia")
    .max-width-grid
      h4.white How does social media play a role in looking for holiday gifts?
      p.subhead Shoppers using social media to look for information about Thanksgiving weekend sales and promotions:<span class="super"><a href="https://www.slideshare.net/NationalRetailFederation/holiday-2018-consumer-trends" target="_blank">2</a></span>
      .chart-wrap
        SocialMediaInfluence
        .text-block.one.top
          p.p2 Facebook
        .text-block.two.top
          p.p2 Instagram
        .text-block.three.top
          p.p2 Pinterest
        .text-block.four.top
          p.p2 Twitter
        .text-block.five.btm
          p.p2 All shoppers
        .text-block.six.btm
          p.p2 Ages 18—24
        .text-block.seven.btm
          p.p2 Ages 25—34
</template>

<script>
import SocialMediaInfluence from '@/assets/img/barCharts/socialMediaInfluence.svg'

export default {
  name: 'socialMediaRoleSlide',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const getBars = this.$el.querySelectorAll('rect')
    const heights = [...getBars].map(el => el.getAttribute('height'))
    const yVal = [...getBars].map(el => el.getAttribute('y'))

    this.timeline = new TimelineLite({ paused: true })
   
    getBars.forEach((bar, i) => {
      let height = parseFloat(heights[i])
      let y = parseFloat(yVal[i])
      let animateFrom = height + y
      this.timeline
        .fromTo(bar, 1, {attr: { y: animateFrom, height: 0 } }, {attr:{ y: yVal[i], height: heights[i] } }, '-=0.75')
    })
  },
  computed: {
  },
  methods: {
    playAnimation () {
      this.timeline.seek(0)
      this.timeline.play()
    },
  },
  components: {
    SocialMediaInfluence,
  },
}
</script>

<style scoped lang="scss">
.socialMediaRoleSlide {
  height: 58rem;
  padding-top: 5rem;
  text-align: center;

  h4 {
    padding-bottom: 3.7rem;
  }

  .subhead {
    color: white;
    width: 40%;
    padding-bottom: 3.3rem;
    margin: 0 auto;
    line-height: 1.5rem;
  }

  .chart-wrap {
    max-width: 71%;
    margin: 0 auto;
    position: relative;
  }

  .super {
    a {
      color: #fff;
    }
  }

  .p2 {
    color: #fff;
  }

  .text-block {
    &.top { top: 69% }
    &.btm { top: 90% }
    &.one { left: 8%; }
    &.two { left: 33%; }
    &.three { left: 58.5%; }
    &.four { left: 85.5%; }
    &.five { left: 25%; }
    &.six { left: 48.5%; }
    &.seven { left: 70.5%; }
  }

  @media #{$mobile} {
    .chart-wrap {
      max-width: 78%;
    }

     h4 {
      padding-bottom: 2rem;
    }

    .subhead {
      line-height: 2.8rem;
      width: 53%;
    }
  }
}
</style>
